import React, { Component, Fragment } from 'react'
import moment from 'moment'
import { toast } from 'react-toastify'
import setQuery from 'set-query-string'
import { parseQuery } from '../../utils'
import isNull from 'lodash/isNull'
import API from '../../api'
import { FormattedMessage, intlShape, injectIntl } from 'react-intl'
import PriceConverter from '../helpers/PriceConverter'
import Pagination from 'react-js-pagination'
import ShopSlider from '../search/ShopSlider'
import PlaceholderTrip from './PlaceholderTrip'
import { setOperatorIconClass, getOperatorTypeTitle } from '../popups/GroupBookingPopup'
import DateFormat from '../helpers/DateFormat'

const PAGE_SIZE = 10

class TripItem extends Component {
  constructor(props) {
    super(props)

    const query = parseQuery()

    this.state = {
      loading: true,
      page: query && query.page ? +query.page : 1,
      shops: [],
      pageCount: 0,
    }

    this.tripContainerRef = React.createRef()
  }

  onPageChange = (page) => {
    window.scrollTo(0, this.tripContainerRef.current.offsetTop)
    setQuery({ page })
    this.setState({
      page,
      loading: true,
    }, this.getTrips)
  }

  componentDidMount() {
    this.getTrips()
  }

  componentDidUpdate(prevProps) {
    if(JSON.stringify(prevProps.selectedParams) !== JSON.stringify(this.props.selectedParams) ||
      prevProps.getNewData !== this.props.getNewData
    ) {
      this.setState({
        page: 1,
        loading: true,
      }, this.getTrips)
    }
  }

  getTrips = () => {
    const { model, pk } = this.props

    // let highlightSlug = ''

    // if(window.highlightedShopSlug && window.highlightedShopSlug !== '') {
    //   highlightSlug = window.highlightedShopSlug + '/'
    // }
    return API(`search/${model.toLowerCase()}/${pk}/group-trips/`).get({
      ...this.props.selectedParams,
      page_size: PAGE_SIZE,
      page: this.state.page,
    }).then((data) => {
      const shops = data.results

      this.props.setNumberOfItems(data.count, 'numberOfBoats')

      this.setState({
        shops,
        loading: false,
        numberOfTrips: data.count,
      })
    }).catch(() => {
      this.setState({
        loading: false,
        numberOfTrips: 0,
        shops: [],
      })

      toast.error(<FormattedMessage id='went_wrong' defaultMessage='Something went wrong' />, {
        position: toast.POSITION.TOP_CENTER,
      })
    })
  }

  queriesForWidget() {
    if(!this.props.isWidget) {
      return null
    }

    const params = parseQuery()

    let query = `?utm_campaign=WW-ALL-ALL-DI-Affiliates&utm_medium=widget&utm_content=${params.popup ? 'search_modal' : 'search_iframe'}&`

    if(params.aid) {
      query += `utm_source=affiliate_${params.aid}&aid=${params.aid}&`

      if(params.cid) {
        query += `cid=${params.cid}`
      }
    }

    return query
  }

  displayTripLanguage(languages) {
    let trips = ''
    let langsMsg = <FormattedMessage id='trip_language' defaultMessage='(trip language)' />
    if(languages.length > 1) {
      langsMsg = <FormattedMessage id='trip_languages' defaultMessage='(trip languages)' />
    }
    languages.map((language, index) => {
      if(index > 0) {
        trips += ', '
      }
      trips += language.title
    })

    return (
      <span>
        {trips} {langsMsg}
      </span>
    )
  }

  render() {
    const { shops, loading } = this.state
    if(loading) {
      return (
        <Fragment>
          {
            [...new Array(10)].map((_, i) => {
              return (<PlaceholderTrip key={i} />)
            })
          }
        </Fragment>
      )
    }
    return (
      <div ref={this.tripContainerRef} className='results'>
        { ((shops && !shops.length === 0) || !shops) && (<div>
          <FormattedMessage id='no_results' defaultMessage='No results match your search criteria' />
        </div>)}
        {
          shops.map((trip) => {
            return (
              <div key={trip.url} className={`boat search-page-item-card ${trip.isHighlighted ? 'highlighted' : ''}`}>
                <div className='boat-info'>
                  <div className='photo-slider'>
                    <ShopSlider apiUrl={trip.imageApiUrl} shopUrl={trip.url} slug={trip.slug} background={trip.background.FeaturedDealsBigTabletLand} />
                  </div>
                  <div className='shop-info' onClick={(e) => {
                    e.stopPropagation()
                    window.open(trip.url, '_blank')
                  }}>
                    <div className='shop-head'>
                      <a className='shop-title' target='_blank' href={trip.url}>
                        <span>{ trip.title }</span>
                      </a>
                    </div>
                    <div className='shop-desc group-trip-description'>
                      <div className='shop-desc-text'>
                        <ul className='group-trip-info'>
                          <li>
                            <i className={`font-icons ${setOperatorIconClass(trip.operatorType)}`} />
                            { getOperatorTypeTitle(trip.operatorType) }
                          </li>
                          <li>
                            <i className='font-icons location-icon' />
                            { trip.countryTitle }
                          </li>
                          <li>
                            <i className='font-icons calendar-icon' />
                            <DateFormat date={trip.dateStart} format={trip.dateStart.substr(0, 4) === trip.dateEnd.substr(0, 4) ? 'DD MMM' : 'DD MMM YYYY'} /> - <DateFormat date={trip.dateEnd} format='DD MMM YYYY' />,
                            &nbsp;<FormattedMessage id='night_qty' values={
                              { qty: moment(trip.dateEnd).diff(trip.dateStart, 'd') }
                            } defaultMessage='{qty, plural, one {# night} other {# nights}}' />
                          </li>
                          <li>
                            <i className='font-icons peoples-icon' />
                            { trip.groupSizeMax === trip.groupSizeMin ? (
                              <FormattedMessage id='people_group_same'
                                values={{
                                  max: trip.groupSizeMax,
                                }}
                                defaultMessage='{max} people group' />
                            ) : (
                              <FormattedMessage id='people_group'
                                values={{
                                  min: trip.groupSizeMin,
                                  max: trip.groupSizeMax,
                                }}
                                defaultMessage='{min} - {max} people group' />
                            )
                            }
                          </li>
                          {trip.languages && trip.languages.length &&
                            (<li>
                              <i className='font-icons chat-icon' />
                              {this.displayTripLanguage(trip.languages)}
                            </li>)
                          }
                        </ul>
                        { trip.organiser && (
                          <div className='operator-teaser'>
                            <div className='operator-teaser__image'>
                              <img src={trip.organiser.background.ExtranetPreview} />
                            </div>
                            <div className='operator-teaser__info-wrapper'>
                              <p className='operator-teaser__title bold'>{ trip.organiser.title }</p>
                              <p className='operator-teaser__info'>{ trip.organiser.formattedAddress }</p>
                              { trip.organiser.tripAdvisor && (<div className='rating-wrap tripadvisor'>
                                <div className='tripadvisor-rating-wrap'>
                                  <img src={trip.organiser.tripAdvisor.ratingImageUrl} />
                                  <span className='rating-count'>
                                    <a href={trip.organiser.tripAdvisor.webUrl} target='_blank'>{trip.organiser.tripAdvisor.numReviews} <FormattedMessage id='reviews' defaultMessage='Reviews' /></a></span>
                                </div>
                              </div>) }
                            </div>
                          </div>
                        ) }
                      </div>
                      <div className='prices'>
                        {
                          trip.price && (trip.itemsLeft > 0 || isNull(trip.itemsLeft)) ? (
                            <div className='price'>
                              <p className='cur-price'>
                                <small><FormattedMessage id='from' defaultMessage='From' /></small>
                                <strong><PriceConverter amount={trip.price.value} currency={trip.price.currency} /></strong>
                              </p>
                              <p className='price-info'><FormattedMessage id='per_person' defaultMessage='per person' /></p>
                              { trip.itemsLeft !== null && trip.itemsLeft <= 4 ? (
                                <span className='spots-number'>
                                  <FormattedMessage id='spots_left' values={{
                                    qty: trip.itemsLeft,
                                  }} defaultMessage='Only { qty, plural, one {# spot } other {# spots } } left' />
                                </span>) : ''
                              }
                            </div>) : '' }

                        { trip.itemsLeft === 0 ? <span className='sold-out-group'>
                          <i className='font-icons fail-icon-new' />&nbsp;
                          <FormattedMessage id='sold_out' defaultMessage='Sold out' />
                        </span> : ''}
                        <button className='btn-red'><FormattedMessage id='view_trip' defaultMessage='View trip' /></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>)
          })
        }
        { this.state.numberOfTrips > 10
          ? (<div className='pagination-wrap'>
            <Pagination
              activePage={this.state.page}
              innerClass='custom-pagination'
              itemsCountPerPage={PAGE_SIZE}
              itemClassPrev='prev'
              itemClassNext='next'
              prevPageText=''
              nextPageText=''
              itemClassFirst='hidden'
              itemClassLast='hidden'
              totalItemsCount={this.state.numberOfTrips}
              pageRangeDisplayed={5}
              onChange={this.onPageChange}
            />
          </div>) : ''
        }
      </div>
    )
  }
}

TripItem.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(TripItem)
